module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAASCAYAAACAa1QyAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC4SURBVCiRldKhjUJBFIXh7xEkAoFAIl4BCAQFIF4JSJKlBBK2hE0Q0AE46AAS6ACBXLFi5YoVNEACYiB5jju/GnHPnLlnTiGPD4yiw21s8Y1+RDDELzZovRtuYo4rxpHbuzjijF5EUOEfX0+3t89Z4k8woRIXHNCJCCbSsrPIMDRwe57vUdGLUkpqLyUXpomVFESV6/qKfCEQeZ0uTjI+t86njBrVGUiFXQsUtk4LO/ygX2S6TlE9ANzgHZG5w+zkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/prev_page.png
// module id = XLu9
// module chunks = 8